import { useIsGb } from 'shared/hooks/useIsGb';

export const useCurrencySymbol = () => {
  const isGb = useIsGb();

  return isGb ? '£' : '€';
};
